import React, { useState } from 'react';
import loadable from '@loadable/component';

const SearchBox = loadable(() => import('./index'), { ssr: false });
const MenuItem = loadable(() => import('./menu-item'), { ssr: false });

export default function DynamicSearchBox({ page, processSearchBoxResponse }) {
    const [loadSearch, setLoadSearch] = useState({ load: false, focus: false });

    const searchFilters = {
        template_key: 'blog',
        hosted: 'true',
        blog_archive: 'false',
    };

    const onSearch = focus => {
        setLoadSearch({ load: true, focus });
    };

    const SearchPlaceholder = () => (
        <div
            className="blog-search-box"
            onMouseOver={() => onSearch(false)}
            onFocus={() => onSearch(true)}
            onTouchStart={() => onSearch(true)}
        >
            <div className="search-icon-container">
                <span className="search-icon"></span>
            </div>
            <span
                data-metrics-event-name="linkClick"
                data-metrics-event="e_linkClick"
                data-metrics-link-id="blog-search-box:clicked"
            >
                <div className="rbt" tabIndex="-1" style={{ outline: 'none', position: 'relative' }}>
                    <div style={{ display: 'flex', flex: '1 1 0%', height: '100%', position: 'relative' }}>
                        <input className="rbt-input-main form-control rbt-input" placeholder="Search for articles..." />
                        <input
                            style={{
                                backgroundColor: 'transparent',
                                borderColor: 'transparent',
                                boxShadow: 'none',
                                color: 'rgba(0, 0, 0, 0.35)',
                                left: '0px',
                                pointerEvents: 'none',
                                position: 'absolute',
                                top: '0px',
                                width: '100%',
                            }}
                        />
                    </div>
                </div>
            </span>
        </div>
    );

    return (
        <>
            {loadSearch.load ? (
                <SearchBox
                    focus={loadSearch.focus}
                    fallback={<SearchPlaceholder />}
                    engine={'hp-store-pages'}
                    filters={searchFilters}
                    page={page}
                    processSearchBoxResponse={processSearchBoxResponse}
                    labelKey={option => option.blogTitle}
                    menuItem={(result, index, searchText, updateSearchBoxInput, numOfResults) => {
                        return (
                            <MenuItem
                                {...result}
                                key={index}
                                option={result}
                                position={index}
                                searchText={searchText}
                                updateSearchBoxInput={updateSearchBoxInput}
                                numOfResults={numOfResults}
                            />
                        );
                    }}
                />
            ) : (
                <SearchPlaceholder />
            )}
        </>
    );
}
